














































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MachineListHeader extends Vue {
  private doSort (name: string) {
    this.$emit('machine-sort', name)
  }
}
